'use client'

import { Skeleton } from '@macarongfactory/web-ui'

import RankHeader from './_components/RankHeader'
import RankInAppTopBar from './_components/RankInAppTopBar'
import RankLnb from './_components/RankLnb'
import {
  checkIsInApp,
  RANK_DEFAULT_SEGMENT,
  RANK_SEGMENTS,
} from './_features/rank'

/** 스켈레톤 카드 반복 수 — 뷰포트를 채우는 정도 (Figma 8453:67092 / 8453:66583) */
const SKELETON_CARD_REPEAT = 5

/** LNB는 정적 콘텐츠라 로딩 중에도 실제로 노출 — 선택 핸들러만 비활성화 */
const noop = () => {}

/**
 * 랭킹 페이지 로딩 스켈레톤 — Figma 8453:66583(모바일) / 8453:67092(데스크탑)
 * - 상단: 인앱은 인앱 상단바(RankInAppTopBar), 데스크탑 웹은 검색 헤더(RankHeader, 로고+검색)
 *   모바일 웹은 탭 전환 시 헤더 없이 스켈레톤만 노출한다(로고 깜빡임 방지, WEB-4630 확장)
 * - 모바일: 콘텐츠 DS Skeleton(카드 패턴, 풀폭)
 * - 데스크탑: 실제 차급 LNB + 콘텐츠 DS Skeleton (2컬럼)
 */
const RankLoading = () => (
  <div className='min-h-screen bg-background-surface-default lg:bg-background-surface-basement'>
    {/* GNB는 전체 폭, 본문만 max-w로 가둔다 (WEB-4616).
        인앱은 로고 헤더 대신 인앱 상단바. 모바일 웹은 헤더를 숨겨(hidden lg:block)
        탭 전환 스켈레톤에서 로고가 튀지 않게 한다 (WEB-4630) */}
    {checkIsInApp() ? (
      <RankInAppTopBar />
    ) : (
      <div className='hidden lg:block'>
        <RankHeader />
      </div>
    )}
    <div className='mx-auto flex w-full max-w-[1024px] flex-col bg-background-surface-default lg:bg-transparent'>
      {/* 모바일 / 인앱 */}
      <div className='pt-dimension-x2 lg:hidden'>
        <Skeleton pattern='card' repeat={SKELETON_CARD_REPEAT} />
      </div>

      {/* 데스크탑 */}
      <div className='hidden gap-dimension-x6 px-dimension-x5 py-dimension-x6 lg:flex'>
        <RankLnb
          segments={RANK_SEGMENTS}
          activeSegment={RANK_DEFAULT_SEGMENT}
          onSelect={noop}
        />
        <div className='min-w-px flex-1'>
          <Skeleton pattern='card' repeat={SKELETON_CARD_REPEAT} />
        </div>
      </div>
    </div>
  </div>
)

export default RankLoading
